import { websockets } from '../../engine/websockets-sidecar'
import { common } from '../../main/common-sidecar'
import { uiFps } from '../../ui/uiFps-sidecar'
import { buttons2 } from '../../uiParts/buttons2-sidecar'
import { clickEater } from '../../uiParts/clickEater-sidecar'
import { stevieTexts2 } from '../../uiParts/stevieTexts2-sidecar'
import { chessAiRando } from './ai/chessAiRando-sidecar'
import { chessBackground } from './chessBackground-sidecar'
import { chessCamera } from './chessCamera-sidecar'
import { chessGameManager } from './chessGameManager-sidecar'
import { chessParticles } from './chessParticles-sidecar'
import { chessPicker } from './chessPicker-sidecar'
import { chessPieces } from './chessPieces-sidecar'
import { chessProgressBars } from './chessProgressBars-sidecar'
import { chessWebsockets } from './messages/chessWebsockets-sidecar'
import { chessShaderTest } from './tests/chessShaderTest-sidecar'
import { chessSpyders } from './tests/chessSpyders-sidecar'
import { chessUiGame } from './ui/chessUiGame-sidecar'
import { chessUiGameMultiplayer } from './ui/chessUiGameMultiplayer-sidecar'
import { chessUiMenuMain } from './ui/chessUiMenuMain-sidecar'
import { chessUiMessage } from './ui/chessUiMessage-sidecar'
import { chessUiMultiListGames } from './ui/chessUiMultiListGames-sidecar'
import { chessUiMultiplayerCursors } from './ui/chessUiMultiplayerCursors-sidecar'
import { chessUiPrompt } from './ui/chessUiPrompt-sidecar'
import { chessUiSettings } from './ui/chessUiSettings-sidecar'
import { chessUiSetupAI } from './ui/chessUiSetupAI-sidecar'
import { chessUiSetupGameRules } from './ui/chessUiSetupGameRules-sidecar'

export const update = (time: number, delta: number) => {
  // let ctx = goatScene.getContext()
  common.setUpdateDelta(delta / 1000)
  let curSpeedScale = 1

  // if (voyageGameManager.get().isPaused) {
  //   curSpeedScale = 0
  // }

  // if (voyageGameStatus.get().isGameEnded) {
  //   curSpeedScale = 0
  // }

  common.setUpdateDeltaScaled((delta / 1000) * curSpeedScale)

  chessCamera.update()
  chessGameManager.update()
  chessAiRando.updateAll()

  chessPicker.update()
  chessPieces.updateAll()
  chessProgressBars.updateAll()

  uiFps.update(chessCamera.getGameBounds())

  buttons2.updateAll()

  chessUiMessage.update()
  chessUiPrompt.update()
  chessUiSettings.update()
  chessUiMultiListGames.update()
  chessUiSetupAI.update()
  chessUiSetupGameRules.update()

  chessUiMenuMain.update()
  chessUiGame.update()

  chessBackground.update()

  websockets.update()
  chessUiGameMultiplayer.update()
  chessUiMultiplayerCursors.updateAll()

  chessParticles.updateAll()
  stevieTexts2.updateAll()
  clickEater.updateAll()

  chessSpyders.updateAll()
  chessShaderTest.update()
}
